import React, { ReactNode } from "react";
import styles from "./modal-overlay.module.scss";

interface ModalOverlayProps {
  children: ReactNode;
  closeModal?: () => void;
  modalOverlay?: string;
}

export default function ModalOverlay({
  children,
  closeModal,
  modalOverlay,
}: ModalOverlayProps) {
  return (
    <div className={`${styles.overlay} ${modalOverlay ?? ''}`} onClick={closeModal}>
      {children}
    </div>
  );
}
